export const es = {
  daterange: {
    on: 'El {1}',
    to: '{1} Hasta {2}',
    after: 'Después del {1}',
    before: 'Antes del {1}',
    today: 'Hoy',
    yesterday: 'Ayer',
    tomorrow: 'Mañana',
    last: '{1} Pasado',
    next: 'Proximo {1}',
  },
  pikaday: {
    today: 'Hoy',
    previousMonth: 'Mes Pasado',
    nextMonth: 'Promimo Mes',
    months: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  },
};
